export default function formatMessageContentAudio ({
    url,
    localId,
    name,
    size,
    type,
    duration = 0 // 与后端统一，单位为秒
}) {
    return {
        media: {
            duration: Math.ceil(duration),
            url,
            localId,
            name,
            size: Number(size),
            type
        }
    }
}
